export interface IDevicePosition {
    latitude?: string;
    longitude?: string;
}
